import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { IExam } from "../../../types";

interface ExamsProps {
  exams: IExam[] | undefined;
}

const useStyles = makeStyles(() => ({
  exam: {
    fontSize: 12,
    display: "flex",
    justifyContent: "space-between",
    "& + &": {
      marginTop: 10,
    },
  },
}));

export const ExpandedExams: FC<ExamsProps> = ({ exams }) => {
  const classes = useStyles();

  return (
    <div>
      {exams?.map((exam) => (
        <div key={exam.name} className={classes.exam}>
          <div>{exam.name}</div>
          <div>{exam.score}</div>
        </div>
      ))}
    </div>
  );
};
